import StatementPreferencePage, { getDefaultPageUI, getStatementPreferenceItem } from "components/pages/StatementPreferencePage";
import { BCMSStateManagerCRUD } from "bcms-react";

export default function CaptureEStatementsEnrollDropdown(props) {
    const { key, value } = getStatementPreferenceItem("0");

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ key ], { ...value, selectIsActive: true })
        .submit();

    return <StatementPreferencePage ui={ ui } />
}